import fetch from 'auth/FetchInterceptor'

const JwtAuthService = {}

JwtAuthService.login = function (data) {

	return fetch({
		url: '/api/usuarios/login',
		// credentials: 'include',
		method: 'post',
		headers: {
		'public-request': 'true',
		// 'credentials': 'include',
		},
		data: data
	})
}

JwtAuthService.loginGoogle = function (id_institucion,token) {
	return fetch({
		url: '/api/usuarios/login/google',
		method: 'post',
		headers: {
		'public-request': 'true',
		},
		data: {id_institucion,token}
	})
}


JwtAuthService.logout = function (data) {

	return fetch({
		url: '/api/pruebas/removeGalleta?id='+data,
		method: 'get',
		credentials: 'same-origin',
		headers: {
		'public-request': 'true',
		},
	})
}

JwtAuthService.signUp = function (data) {
	return fetch({
		url: '/api/usuarios/register_account',
		method: 'post',
		headers: {
      'public-request': 'true'
    },
		data: data
	})
}

JwtAuthService.verifyAccount = function (params) {
	return fetch({
		url: '/api/usuarios/activate_user',
		method: 'get',
		headers: {
      'public-request': 'true'
    },
		params
	})
}

export default JwtAuthService